import { TICKETING_PROVIDER_FLAGS } from '@neo.tax/shared/constants';
import { TicketingProvider } from '@neo.tax/shared/graphql';
import { useFlags } from '@neo.tax/shared/third-parties';

import { TicketingProviderCardProps } from '../connect-account.types';
import { toTicketingProviderCards } from '../connect-account.utils';
import { useTicketingProviderIds } from './useTicketingProviderIds';

export const useTicketingProviderCards = ({
  connectedProviders,
  enabled,
}: {
  enabled: boolean;
  connectedProviders: Set<TicketingProvider>;
}): TicketingProviderCardProps[] => {
  const ticketingAccountIds = useTicketingProviderIds();
  const flags = useFlags();
  if (!enabled) return [];
  const ticketingIds: {
    provider: TicketingProvider;
    analyticId: string;
    connected: boolean;
  }[] = [
    {
      provider: TicketingProvider.Asana,
      analyticId: ticketingAccountIds.asanaRadioId,
      connected: connectedProviders.has(TicketingProvider.Asana),
    },
    {
      provider: TicketingProvider.JiraCloud,
      analyticId: ticketingAccountIds.jiraRadioId,
      connected: connectedProviders.has(TicketingProvider.JiraCloud),
    },
    {
      provider: TicketingProvider.JiraDataCenter,
      analyticId: ticketingAccountIds.jiraDataCenterRadioId,
      connected: connectedProviders.has(TicketingProvider.JiraDataCenter),
    },
    {
      provider: TicketingProvider.Linear,
      analyticId: ticketingAccountIds.linearRadioId,
      connected: connectedProviders.has(TicketingProvider.Linear),
    },
    {
      provider: TicketingProvider.Trello,
      analyticId: ticketingAccountIds.trelloRadioId,
      connected: connectedProviders.has(TicketingProvider.Trello),
    },
    {
      provider: TicketingProvider.GithubIssues,
      analyticId: ticketingAccountIds.githubRadioId,
      connected: connectedProviders.has(TicketingProvider.GithubIssues),
    },
    {
      provider: TicketingProvider.Shortcut,
      analyticId: ticketingAccountIds.shortcutRadioId,
      connected: connectedProviders.has(TicketingProvider.Shortcut),
    },
  ].filter(({ provider }) => TICKETING_PROVIDER_FLAGS[provider] && flags[TICKETING_PROVIDER_FLAGS[provider]]);
  return toTicketingProviderCards(ticketingIds);
};
